import actions from "@/store/modules/users/languagesAndSkills/actions";
import {
  mutations,
  state
} from "@/store/modules/users/languagesAndSkills/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
